<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            <b> DFS Prediction Quiz List </b>

            <CButton
              block
              color="success"
              style="float: right; width: 120px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="tableData"
            :fields="fields"
            pagination
            clickable-rows
            hover
          >
            <template #image="{ item }">
              <td>
                <img :src="item.image" style="width: 50px; height: 50px" />
              </td>
            </template>
            <template #status="{ item }">
              <td v-if="item.endtime.seconds < todaydate.seconds">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                  completed
                </a>
              </td>
              <td v-else>
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-primary ml-1"
                >
                  Live
                </a>
              </td>
            </template>
            <!-- <template #status="{ item }">
              <td>
                <span v-if="item.status == true">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-success ml-1"
                  >
                    Active
                  </a></span
                >
                <span v-else>
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-danger ml-1"
                  >
                    InActive
                  </a>
                </span>
              </td>
            </template> -->
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="editToken(item, index)"
                >
                  Edit </CButton
                ><br /><br />
              </td>
            </template>
            <template #completed="{ item, index }">
              <br />
              <CButton
                style="margin-top: -15px"
                v-if="item.completed"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="modelopen(item, index)"
              >
                Set Answer
              </CButton>
            </template>
          </CDataTable>
          <CModal title="Add Prediction Answer" :show.sync="myModal">
            <CCol sm="12">
              <label>Prediction Title</label>
              <CInput
                style="color: black; font-weight: bold"
                placeholder="Enter MatchID"
                v-model="Quiztitle"
                disabled
              />
            </CCol>
            <CCol sm="12">
              <label>Prediction Question</label>
              <CInput
                style="color: black; font-weight: bold"
                placeholder="Enter MatchID"
                v-model="Quizquestion"
                disabled
              />
            </CCol>
            <CCard style="padding: 10px">
              <CRow>
                <!-- :value="this.option1" -->
                <CCol sm="3" v-for="answer in options" :key="answer">
                  <input
                    type="radio"
                    v-model="quizAnswer"
                    name="profileImg"
                    :value="answer"
                  />
                  <span style="color: black; font-weight: bold">
                    {{ answer }}</span
                  >
                </CCol>
              </CRow>
            </CCard>
            <CCard style="padding: 10px" v-if="answeravailable">
              <h5>
                Selected answer is <u>{{ quizAnswer }}</u>
              </h5>
            </CCard>
            <template #footer>
              <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
              <CButton color="success" :disabled="isActive" @click="sendAnswer()">Save</CButton>
            </template>
          </CModal>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.17/vue.js"></script>
<script>
import CTableWrapper from "../tables/Table";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import { secondaryDatabase } from "./secondary.js";
import moment from "moment";
import axios from "axios";
export default {
  components: { CTableWrapper },
  data() {
    return {
      answeravailable: false,
      options: [],
      profileImg: "",
      myModal: false,
      quizAnswer: "",
      isActive:false,
      fields: [
        {
          label: "Image",
          key: "image",
          sortable: true,
        },
        {
          label: "Date",
          key: "Date",
          sortable: true,
        },
        {
          label: "StartDate",
          key: "StartDate",
          sortable: true,
        },
        {
          label: "EndDate",
          key: "EndDate",
          sortable: true,
        },
        // {
        //   label: "Title",
        //   key: "quizTitle",
        //   sortable: true,
        // },
        {
          label: "Status",
          key: "status",
          sortable: true,
        },

        // {
        //   key: "Action",
        //   sortable: true,
        // },
        {
          label: "completed",
          key: "completed",
          sortable: true,
        },
      ],
      speciesCode: null,
      speciesName: "",
      documentId: "",
      tableData: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      image1: false,
      todaydate: null,
      Quiztitle: "",
      Quizquestion: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
    };
  },
  watch: {
    quizAnswer() {
      if (this.quizAnswer != "") {
        this.answeravailable = true;
      }
    },
  },
  methods: {
    check(event) {},
    modelopen(item, index) {
      this.myModal = true;
      secondaryDatabase
        .collection("quizprediction")
        .doc(item.id)
        .get()
        .then((snapshot) => {
          (this.Quiztitle = snapshot.data().quizTitle),
            (this.Quizquestion = snapshot.data().question),
            (this.options = snapshot.data().options);
          this.quizId = snapshot.id;
          this.points = snapshot.data().point;
        });
    },
    sendAnswer() {
      if (this.quizAnswer == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz Answer",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        this.isActive = true;
        let docId = this.quizId;
        let answer = this.quizAnswer;
        let points = this.points;
        let data = {
          docId,
          answer,
          points,
        };

        axios.post(
          "https://us-central1-token-geomine.cloudfunctions.net/dfs/addpredictionpoint",
          { ...data }
        );
        //  axios.post("http://localhost:5000/token-geomine/us-central1/dfs/addpredictionpoint", { ...data })
        secondaryDatabase
          .collection("quizprediction")
          .doc(this.quizId)
          .update({
            answer: this.quizAnswer,
          })
          .then((res) => {});
          this.isActive = false;
        Swal.fire({
          position: "center",
          icon: "success",
          title: "saved successfully",
          showConfirmButton: false,
          timer: 3000,
        });

        window.setInterval(() => {
          this.reload();
        }, 3000);

        // Swal.fire({
        //   position: "center",
        //   icon: "warning",
        //   title: "saved",
        //   showConfirmButton: false,
        //   timer: 3000,
        // });
        // this.reload();
        //   axios.post("https://us-central1-token-geomine.cloudfunctions.net/dfs/addpredictionpoint", { ...data })
        //   axios.post("http://localhost:5000/token-geomine/us-central1/dfs/addpredictionpoint", { ...data })
        //  .then((res) => {
        //  })
      }
    },

    reload() {
      window.location.reload();
    },
    wizard() {
      this.$router.push({ name: "addPrediction" });
    },
    editToken(item, index) {
      this.$router.push({
        name: "editPrediction",
        params: { id: item.id, data: "DFS" },
      });
    },

    getquiz() {
      this.tableData = [];
      // let dbs = secondaryDB.secondaryDatabase;
      secondaryDatabase
        .collection("quizprediction")
        .where("dfs", "==", true)
        .where("answer", "==", null)
        .orderBy("quizdate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push({
              id: doc.id,
              quizTitle: doc.data().quizTitle,
              question: doc.data().question,
              options: doc.data().options,
              answer: doc.data().answer,
              status: doc.data().status,
              image: doc.data().image,
              quiztype: doc.data().quiztype,
              starttime: doc.data().starttime,
              endtime: doc.data().endtime,
              scramble: doc.data().scramble,
              dfs: doc.data().dfs,
              completed: doc.data().endtime.seconds < this.todaydate.seconds,
              Date: moment(doc.data().quizdate.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              StartDate: moment(doc.data().starttime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              EndDate: moment(doc.data().endtime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
            });
          });

          this.loading = false;
        });
    },
    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails2")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.getquiz();
    this.todaydate = firebase.firestore.Timestamp.fromDate(new Date());
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
</style>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
.badge-warning {
  color: white;
  background-color: #f9b115;
}
.modal-dialog {
  max-width: 550px;
  margin: 1.75rem auto;
}
</style>
